import { FC, ReactNode, useEffect } from 'react'
import { Popover } from 'antd'
import s from './index.module.less'

interface TopsDetailProps {
  userInfo: any
  children: ReactNode
  onBuyClick?: () => void
  onBuyTopsClick?: () => void
}

const TopsDetail: FC<TopsDetailProps> = ({ userInfo, children, onBuyClick, onBuyTopsClick }) => {
  // 会员判断：is_vip 为 true 时展示【购买算力】，否则展示【购买会员】
  const isVip = !!userInfo?.is_vip
  const onConsumeClick = () => {
    const urlHost = process.env.REACT_APP_ENV === 'pro' ? 'https://user.3d66.com' : 'https://usertest.3d66.com'
    window.open(`${urlHost}/newUser/asset/index/list?tab=ai_compute`)
  }
  return (
    <Popover
      placement='bottom'
      title={''}
      classNames={{ root: s.modelPopover }}
      arrow={false}
      align={{ offset: [0, 10] }}
      content={() => (
        <div className={s.popContent} onClick={(e) => e.stopPropagation()}>
          <div className='head'>
            <div className='headL'>
              <span className={s.iconTops}></span>
              <span className='powerTxt'>当前算力：{(userInfo && userInfo.total_tops) || 0}</span>
            </div>
            <div className='headR'>
              <span>算力说明</span>
              <Popover placement='bottom' title={''} classNames={{ root: s.explainPopover }} arrow={true}
                content={() => 
                <div className={s.explainContent}>
                  <div className='exItem'>
                    <div className='exTitle'>免费算力</div>
                    <div className='exTxt'><span>·</span>会员赠送、活动奖励等获得</div>
                    <div className='exTxt'><span>·</span>存在有效期，过期后自动失效</div>
                  </div>
                  <div className='exItem'>
                    <div className='exTitle'>付费算力</div>
                    <div className='exTxt'><span>·</span> 通过购买获得</div>
                    <div className='exTxt'><span>·</span> 永久有效</div>
                  </div>
                  <div className='exItem'>
                    <div className='exTitle'>消耗顺序</div>
                    <div className='exTxt'><span>·</span> 免费算力 → 付费算力</div>
                  </div>
                </div>
                }>
              <i className='iconfont icon-doubt'></i>
              </Popover>
            </div>
          </div>
          <div className='powerCard1'>
            <div className='powerCardRow'>
              <span>免费算力</span>
              <span>{(userInfo && userInfo.free_tops) || 0}</span>
            </div>
            <div className='powerCardExpiry'>{userInfo && userInfo.free_tops_end_time ? `有效期至 ${userInfo.free_tops_end_time}` : '暂无免费算力'}</div>
          </div>
          <div className='powerCard2'>
            <div className='powerCardRow'>
              <span>付费算力</span>
              <span>{(userInfo && userInfo.recharge_tops) || 0}</span>
            </div>
            <div className='powerCardExpiry'>永久有效</div>
          </div>
          <div className='consumeRule'>消耗规则：优先消耗免费算力</div>
          <div className='foot'>
            <div className='footBtn footConsume' onClick={onConsumeClick}>
              消费明细
            </div>
            <div className='footBtn footBuy' onClick={isVip ? onBuyTopsClick : onBuyClick}>
              {isVip ? '购买算力' : '购买会员'}
            </div>
          </div>
        </div>
      )}>
      {children}
    </Popover>
  )
}

export default TopsDetail
